import { render } from "./payList.vue?vue&type=template&id=980eccd0&scoped=true"
import script from "./payList.vue?vue&type=script&lang=js"
export * from "./payList.vue?vue&type=script&lang=js"

import "./payList.vue?vue&type=style&index=0&id=980eccd0&lang=scss&scoped=true"

import exportComponent from "/opt/jenkins/workspace/asoworld-uatnf9mf/asoworld-wap-frontend/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-980eccd0"]])

export default __exports__